"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTtsAudioUrl = void 0;
const zod_1 = require("zod");
const TtsAudioUrlSchema = zod_1.z.string();
const validateTtsAudioUrl = (x) => TtsAudioUrlSchema.safeParse(x);
exports.validateTtsAudioUrl = validateTtsAudioUrl;
//# sourceMappingURL=tts_types.js.map